module.exports = __webpack_public_path__ + "static/media/score.5a10e07c.svg";